module.exports = __webpack_public_path__ + "static/media/pagination-back-all.310dfe9d.svg";